import { z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const MerchantHistoriesDefaultSchemas = DefaultSchemas

export const MerchantHistoriesDataSchemas = zod.object({
  traderId: zod.number().nullable(),
  programUser: zod.string().nullable(),
  programUserId: zod.number().nullable(),
  dateChanged: zod.string().nullable(),
  changedFields: zod.union([zod.string(), zod.null()]).array().nullable(),
  oldValues: zod.string().nullable().array().nullable(),
  newValues: zod.string().nullable().array().nullable(),
  note: zod.string().nullable(),
})

export const MerchantHistoriesAPISchemas = MerchantHistoriesDefaultSchemas.merge(
  zod.object({
    data: zod.array(MerchantHistoriesDataSchemas),
  })
)

export const MerchantHistoriesFetchParamsSchemas = zod.object({
  traderId: zod.number().optional(),
  startDate: zod.string().optional(),
  endDate: zod.string().optional(),
  programUsername: zod.string().optional(),
  pageSize: zod.number().optional(),
  pageNumber: zod.number().optional(),
})
